<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <IFReportHeader :headerData="this.headerData" />
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0 mt-4">
          <h1 class="section_header">Financial Ratios</h1>
          <div class="md-toolbar-row fundamentals_wpr spf-wrapper p-0">
            <nav-tabs-card no-label md-elevation="0">
              <template slot="content">
                <md-tabs md-alignment="left" class="p-0">
                  <md-tab
                    id="cash-flow"
                    md-label="Cash Flow-Solvency"
                    md-icon="money"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFCashRatiosVariance/>
                    </div>
                  </md-tab>
                  <md-tab
                    id="profitability"
                    md-label="Profitability"
                    md-icon="payments"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFProfitabilityVariance/>
                    </div>
                  </md-tab>
                  <md-tab
                    id="efficiency"
                    md-label="Efficiency"
                    md-icon="pie_chart"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFEfficiencyVariance/>
                    </div>
                  </md-tab>
                  <md-tab
                    id="cash-debt-risk"
                    md-label="Cash Debt Risk"
                    md-icon="report"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <IFDebtRiskVariance/>
                    </div>
                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
            <IFReportSidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { NavTabsCard } from '@/components';
import IFReportHeader from './_partials/IFHeader.vue';
import IFReportSidebar from './_partials/IFReportSidebar.vue';
import formatData from '@/mixins/format-data';
import IFCashRatiosVariance from "./IFRatios/IFCashRatiosVariance";
import IFProfitabilityVariance from "./IFRatios/IFProfitabilityVariance";
import IFEfficiencyVariance from "./IFRatios/IFEfficiencyVariance";
import IFDebtRiskVariance from "./IFRatios/IFDebtRiskVariance";

export default {
  name: 'FinancialRatios',
  components:{
    NavTabsCard,
    IFReportHeader,
    IFReportSidebar,
    IFCashRatiosVariance,
    IFProfitabilityVariance,
    IFEfficiencyVariance,
    IFDebtRiskVariance,
    },
    mixins: [formatData],
    props: ['headerData'],
}
</script>
